import React from 'react';
import { ClipboardText } from '@phosphor-icons/react';
import { Tab } from '../../../../components';
import CalculationProperties from './CalculationProperties';
import TreeCart from "../../../../components/Layout-Components/Editor-Layout/Popout-Window/Tree-Cart-Popout/Tree-Cart/TreeCart";
import { TabItem } from '../../../../@types/types';

const PriceCalculation: React.FC = () => {
    const items: TabItem[] = [
        {
            icon: (<ClipboardText size={24} weight='fill' />),
            content: (<CalculationProperties/>),
            title: 'Price Calculation',
            is_active: true,
        }
    ];

    return (
        <>
            <Tab items={items}/>
            <TreeCart />
        </>
    );
}

export default PriceCalculation;